import axiosClient from "@/libs/axiosClient";

export const getMenuItems = ({ menu, groupName }) => {
    return axiosClient.get(`/menuitems?menu=${menu}&groupName=${groupName}`);
};



// WEBPACK FOOTER //
// ./src/api/menu.js